import React, { PureComponent } from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  // Rectangle,
  // LabelList,
  ResponsiveContainer
} from "recharts";
import styles from "./Charts.local.scss";
import {
  CustomizedXAxisTick,
  CustomizedYAxisTick,
  CustomTooltip
} from "./Common";

const defaultColors = ["#2495E1", "#F84154", "#FA9437"];

export class StandardLineChart extends PureComponent {
  render() {
    const {
      chartData,
      dataKeysY,
      dataKeyX,
      currency,
      colors,
      month,
      legendLabels,
      containerWidth,
      containerHeight,
      tooltipValueFormat
    } = this.props;

    let localColors = colors ? colors : defaultColors;
    return (
      <ResponsiveContainer
        width={containerWidth ? containerWidth : "100%"}
        height={containerHeight ? containerHeight : 340}
        className={styles.charts_font}
      >
        <LineChart
          data={chartData}
          margin={{ top: 30, right: 40, left: 15, bottom: 0 }}
        >
          <CartesianGrid vertical={false} stroke="#6d7f92" strokeWidth={0.2} />
          <XAxis
            name={dataKeyX}
            dataKey={dataKeyX}
            height={50}
            interval={0}
            padding={{ left: 20, right: 20 }}
            type="category"
            tick={
              <CustomizedXAxisTick
                handleChangeMonthState={this.props.handleChangeMonthState}
                month={month}
              />
            }
            axisLine={false}
            tickLine={false}
          />
          <YAxis
            tick={<CustomizedYAxisTick currency={currency} />}
            axisLine={false}
            tickLine={false}
            type={"number"}
          />
          <Tooltip content={<CustomTooltip format={tooltipValueFormat} />} />
          <Legend
            verticalAlign="top"
            height={containerHeight ? 20 : 70}
            // align={"center"}
            iconType={"circle"}
            iconSize={8}
            layout={containerHeight ? "horizontal" : "vertical"}
            wrapperStyle={{
              left: 0,
              top: 10,
              fontWeight: 300,
              fontSize: "12px"
            }}
          />
          {dataKeysY.map((item, i) => {
            return (
              <Line
                key={i}
                name={legendLabels[i]}
                type="monotone"
                dataKey={dataKeysY[i]}
                stroke={localColors[i]}
                fill={localColors[i]}
                dot={{ fill: localColors[i], strokeWidth: 4 }}
                strokeWidth={2.5}
                animationEasing={"ease-in-out"}
                animationDuration={800}
              />
            );
          })}
        </LineChart>
      </ResponsiveContainer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Common/Charts/StandardLineChart.js